import { Pagination } from "@mui/material";
import { QuestionMarkIcon } from "@radix-ui/react-icons";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Loader } from "../../components/Widget/Loader";
import clientAxios from "../../services/axios";
import { store } from "../../services/service";
import { useGlobalStore } from "../../store/store";
import {
  AJOUTER_FAQ,
  DELETE_SERVICE_PARTNER,
  LISTE_FAQ,
} from "../../Utils/constant";
import { checkTagValidity } from "../../Utils/Utils";

export const Faq = () => {
  const listFaq = useGlobalStore();
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [statut, setStatut] = useState("LIBRE");
  const [isDeleting, setIsDeleting] = useState(false);

  const handleEdit = () => {
    setIsSubmit(true);
    store(`${AJOUTER_FAQ}/${selectItem?.id}?status=${statut}`)
      .then(() => {
        setIsSubmit(false);
        listFaq.getData(
          `${LISTE_FAQ}?page=0&param=&size=10`,
          "application/json",
          {}
        );
        toast.success("Modification avec succès");
        document.getElementById("update").close();
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
        document.getElementById("update").close();
      });
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(`${AJOUTER_FAQ}`, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer_create").click();
          toast.success("Créer avec succès");
          listFaq.getData(`${LISTE_FAQ}?page=0&param=&size=10`);
        }
      })
      .catch((err) => {
        document.getElementById("fermer_create").click();
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };
  useEffect(() => {
    listFaq.getData(`${LISTE_FAQ}?page=0&param=&size=10`);
  }, []);

  const more = (page) => {
    listFaq.getData(`${LISTE_FAQ}?page=${page - 1}&param=&size=10`);
  };

  return (
    <>
      {checkTagValidity("LISTE_FAQ") ? (
        <div>
          <div className="lg:flex gap-8 items-center">
            <h3 class="font-mtn text-3xl font-bold">Gestion des FAQ FTTH</h3>
          </div>
          <div className="mt-4 lg:flex item-center ">
            <input
              onChange={(e) => {
                listFaq.getData(
                  `${LISTE_FAQ}?page=0&param=${e.target.value}&size=10`
                );
              }}
              type="text"
              placeholder="Rechercher element..."
              className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            />
            <div className="ml-auto flex items-center">
              {checkTagValidity("ENREGISTRER_FAQ") ? (
                <button
                  onClick={() => document.getElementById("add").showModal()}
                  className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
                >
                  Ajouter un FAQ
                </button>
              ) : null}

              <dialog id="add" className="modal ">
                <div className="modal-box ">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold">
                      Ajouter un FAQ
                    </h1>
                    <form method="dialog">
                      <button
                        id="fermer_create"
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <form onSubmit={handleSubmit(submit)} className="px-2">
                    <div className="my-4 space-y-4">
                      <div className="my-2">
                        <label htmlFor="" className="text-sm font-medium">
                          Question <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder=""
                          className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                          {...register("question", { required: true })}
                        />
                        {errors.question && (
                          <span className="text-sm text-rose-600">
                            Ce champs est obligatoire
                          </span>
                        )}
                      </div>

                      <div className="my-2">
                        <label htmlFor="" className="text-sm font-medium">
                          Reponse<span className="text-red-500">*</span>
                        </label>
                        <textarea
                          className="textarea textarea-bordered w-full h-24"
                          placeholder="Reponse"
                          {...register("reponse", { required: true })}
                        ></textarea>
                        {errors.reponse && (
                          <span className="text-sm text-rose-600">
                            Ce champs est obligatoire
                          </span>
                        )}
                      </div>

                      <button
                        type="submit"
                        disabled={isSubmit}
                        className={`${
                          !isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                        } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                      >
                        {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                          <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                      </button>
                    </div>
                  </form>
                </div>
              </dialog>
            </div>
          </div>

          <div className="grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-2 my-8">
            {listFaq?.data?.donnee?.data?.length === 0 ? (
              "Aucune donnée"
            ) : listFaq?.data?.donnee?.data?.length !== 0 &&
              !listFaq?.loading ? (
              listFaq?.data?.donnee?.data?.map((item) => (
                <div className="relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs">
                  <div className="dropdown dropdown-end absolute right-2 top-2">
                    <div
                      tabIndex={0}
                      role="button"
                      className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                    >
                      <MoreHorizontal size={20} />
                    </div>
                    <ul
                      tabIndex={0}
                      className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                    >
                      <button
                        className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("add").showModal();
                        }}
                      >
                        Modifier
                      </button>
                      <button
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("delete").showModal();
                        }}
                        className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                      >
                        Supprimer
                      </button>
                    </ul>
                  </div>
                  <div className="bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                    <QuestionMarkIcon />
                  </div>
                  <div>
                    <p className="truncate w-44">{item?.question}</p>
                    <p className="rounded-full px-2 bg-slate-100 truncate w-fit">
                      {item?.actif ? (
                        <span className="text-green-600 font-semibold">
                          Actif
                        </span>
                      ) : (
                        <span className="text-red-600 font-semibold">
                          Inactif
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <Loader />
            )}
          </div>
          <div className="my-3 flex justify-end">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              onSelect={(selectedPage) => more(selectedPage)}
              count={listFaq.data?.donnee?.totalPages}
              variant="outlined"
              color="primary"
              shape="rounded"
            />
          </div>
          <dialog id="delete" className="modal">
            <div className="modal-box max-w-md rounded-lg">
              <h3 className="font-extrabold text-xl text-red-600 ">
                Attention
              </h3>
              <p className="pt-2 text-black font-medium">
                Voulez vous vraiment effectuer cette action ?
              </p>
              <div className="modal-action">
                <form
                  method="dialog"
                  className="w-full flex items-center justify-end gap-x-4"
                >
                  <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                    Annuler
                  </button>
                  <button
                    onClick={() => {
                      setIsDeleting(true);
                      clientAxios
                        .delete(`${DELETE_SERVICE_PARTNER}/${selectItem.id}`)
                        .then(() => {
                          listFaq.getData(`${LISTE_FAQ}?page=0&param=&size=10`);
                          toast.success("FAQ supprimée avec succès");
                        })
                        .catch((err) => {
                          toast.error(
                            err?.response?.data?.donnee ||
                              "Erreur lors de la suppression"
                          );
                        })
                        .finally(() => {
                          setIsDeleting(false);
                          const dlg = document.getElementById("delete");
                          if (dlg) dlg.close();
                        });
                    }}
                    disabled={isDeleting}
                    className={`bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold ${
                      isDeleting ? "opacity-60 cursor-not-allowed" : ""
                    }`}
                  >
                    {isDeleting ? (
                      <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    ) : null}
                    <span className="ml-2">
                      {isDeleting ? "Suppression..." : "Supprimer"}
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </dialog>
        </div>
      ) : null}
    </>
  );
};
